// Vendor
import * as React from 'react';

// Bernie
import { ClickTracker } from 'bernie-analytics';
import { LocalizedText } from 'bernie-l10n';

// UITK
import { UitkCardLink } from 'uitk-react-cards';

// Components
import { DoubleLink } from 'components/common/media/double-link';
import { ListingComponentProps } from 'components/search/listing';
import { TargetableLink } from 'components/common/targetable-link';

const DoubleLinkTracked = ClickTracker(DoubleLink);

export interface CardLinkProps extends ListingComponentProps {
  listingClickHandler: () => void;
}

export const CardLink: React.FunctionComponent<CardLinkProps> = ({ dataAttributes, index, listingClickHandler, model, referralObject }) => {
  const { infositeUrl, name, pinnedDetails, travelAd } = model;
  const listingDataAttributes = dataAttributes ? dataAttributes.listing : {};
  const analyticHotelOpenProps = referralObject ? referralObject.navigation : {};
  const rfrr = pinnedDetails && pinnedDetails.heading ? `:Pinned:${index}` : `:HotelModule:${index}`;

  const doubleLinkProps = {
    name,
    rfrr,
    className: 'listing__link',
    'data-stid': 'open-hotel-information',
    linkName: 'View selected hotel',
    to: infositeUrl,
    onClick: listingClickHandler,
    ...analyticHotelOpenProps,
    ...listingDataAttributes
  };

  if (travelAd && travelAd.clickRedirectLinkoffTrackingUrl) {
    return <CardLinkBase {...doubleLinkProps} />;
  } else {
    return (
      <TargetableLink>
        <CardLinkBase {...doubleLinkProps} />
      </TargetableLink>
    );
  }
};
CardLink.displayName = 'CardLink';

const CardLinkBase = ({ name, ...doubleLinkProps }) => (
  <UitkCardLink data-stid="listing_link">
    <DoubleLinkTracked {...doubleLinkProps} className="listing__link">
      <LocalizedText message="hotels.search.listing.a11yLabel" data={[name]} />
    </DoubleLinkTracked>
  </UitkCardLink>
);

CardLinkBase.displayName = 'CardLinkBase';
